// extracted by mini-css-extract-plugin
export default {"dot":"Icons_dot__FKISo","showActionsBtn":"Icons_showActionsBtn__HSY0B"};